
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-phone"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-phone"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>
    <div class="edit-nationality-body">
      <div class="modal-form-group">

        @if (dialogData.isProfane==true) {
          <div role="alert" aria-label="error" class="page-error">
            <label>The entry contains inappropriate text, please review and retry.</label>
          </div>
        }
        <label class="dob-label">Emergency contact:</label>
        <div class="cannot-edit-profile-rectangle">

          <input sanitizeInputForm class="form-input" [(ngModel)]="dialogData.emergencyContact" maxlength="100"
            placeholder="Enter emergency contact" [formControl]="dialogData.emergencyContactControl"
            (input)=dialogData.onInputEmergencyContact()>

            @if (dialogData.emergencyContactControl.invalid) {
              <div class="red no-margin">
                @if (dialogData.emergencyContactControl.errors!.required && dialogData.emergencyContactControl.dirty) {
                  <div>
                    Emergency contact cannot be blank
                  </div>
                }
              </div>
            }

          </div>
        </div>
        <div class="btn-container nationality-button">
          <button role="button" tabindex="0" aria-label="save" class="send-button"
            (click)="dialogData.saveEmergencyContact(dialogData.emergencyContact)"
          >Save</button>
        </div>
      </div>

